import * as React from "react";

function SvgIcons8VideoConference(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M3 6v18h26V6zm2 2h22v14H5zm11 2c-1.645 0-3 1.355-3 3 0 .68.238 1.309.625 1.813C12.652 15.543 12 16.698 12 18h2c0-1.117.883-2 2-2s2 .883 2 2h2c0-1.3-.652-2.457-1.625-3.188A2.976 2.976 0 0019 13c0-1.645-1.355-3-3-3zm0 2c.563 0 1 .438 1 1 0 .563-.438 1-1 1-.563 0-1-.438-1-1 0-.563.438-1 1-1zm-7 7v2h4v-2zm5 0v2h4v-2zm5 0v2h4v-2zm-9 6v2h12v-2z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8VideoConference);
